
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface NotificationActionsProps {
  onBack: () => void;
}

export const NotificationActions = ({ onBack }: NotificationActionsProps) => {
  return (
    <Button 
      type="button" 
      variant="outline" 
      onClick={onBack}
    >
      <ArrowLeft className="mr-2 h-4 w-4" /> Terug naar overzicht
    </Button>
  );
};
